import memoize from 'memoize-one';

export default memoize((values, search) => {
  if (search) {
    return values
      ? {
          numberOfOwnBrandItems: 0,
          items: values.filter(
            (value) =>
              value.label.toLowerCase().indexOf(search.toLowerCase()) > -1
          ),
        }
      : { numberOfOwnBrandItems: 0, items: [] };
  }

  return values
    ? {
        numberOfOwnBrandItems: values.filter(
          (value) => value.isBoosted === 'true'
        ).length,
        items: values,
      }
    : { numberOfOwnBrandItems: 0, items: [] };
});
